import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import { Grid, makeStyles } from '@material-ui/core';
import { Appbar } from './components/Appbar';
import { FirstStep } from './pages/FirstStep';
import { SecondStep } from './pages/SecondStep';
import { ThirdStep } from './pages/ThirdStep';
import { FourthStep } from './pages/FourthStep';
// import { FifthStep } from './pages/FifthStep';
import { SixthStep } from './pages/SixthStep';
import { SeventhStep } from './pages/SeventhStep';
import { FinalStep } from './pages/FinalStep';
import { DetailsStep } from './pages/DetailsStep';
import { ContactStep } from './pages/ContactStep';
import { NotFound } from './pages/NotFound';

const useStyles = makeStyles({
  grid: {
    padding: '15px 0 0',
    maxWidth: '500px'
  }
});

const App = () => {
  const classes = useStyles();

  return (
    <>
      <Appbar />
      <main>
        <Grid container justify='center'>
          <Grid item xs={12} md={8} className={classes.grid}>
            <Router>
              <Switch>
                <Route exact path='/' component={FirstStep} />
                <Route exact path='/modelos' component={SecondStep} />
                <Route exact path='/anios' component={ThirdStep} />
                <Route exact path='/versiones' component={FourthStep} />
                {/* <Route exact path='/gnc' component={FifthStep} /> */}
                <Route exact path='/codigo-postal' component={SixthStep} />
                <Route exact path='/datos-personales' component={SeventhStep} />
                <Route exact path='/cotizacion' component={FinalStep} />
                <Route exact path='/detalle' component={DetailsStep} />
                <Route exact path='/contacto' component={ContactStep} />
                <Route component={NotFound} />
              </Switch>
            </Router>
          </Grid>
        </Grid>
      </main>
    </>
  );
};

export default App;
